var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "lab-card-equipment lab-card-equipment--" + _vm.modifier },
    [
      _c("div", { staticClass: "lab-card-equipment__rating" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M7.0013 0.930664L8.95797 4.926L13.3346 5.57066L10.168 8.67866L10.9153 13.0693L7.0013 10.9953L3.0873 13.0693L3.83464 8.67866L0.667969 5.57066L5.04397 4.926L7.0013 0.930664Z",
                fill: "#C39B70"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.protectedRating))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lab-card-equipment__image" },
        [
          _vm.modelPicture
            ? [
                _c("img", {
                  attrs: { src: _vm.modelPicture, alt: _vm.cardName }
                })
              ]
            : _vm.customPicture
            ? [
                _c("img", {
                  attrs: { src: _vm.customPicture, alt: _vm.cardName }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "lab-card-equipment__tooltip lab-card-equipment__tooltip--castom",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-html": "true",
                      title:
                        "<div class='tooltip-body'>Изображения этого оборудования у нас пока нет, но мы это исправим.<br>После модерации здесь появится изображение вашего оборудования.</div>"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [_c("div", { staticClass: "pulse-spot" })]
                )
              ]
            : _vm.slotPicture
            ? [
                _c("img", {
                  attrs: { src: _vm.slotPicture, alt: _vm.cardName }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "lab-card-equipment__tooltip pulse-spot"
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "lab-card-equipment__name" }, [
        _vm._v(_vm._s(_vm.cardName || _vm.equipmentSlot.NAME))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }